export const NULL_UUID = '00000000-0000-0000-0000-000000000000';
export const DEFAULT_MARKETPLACE_UUID = '17f2c056-70c0-48fa-86a1-d4b5ce231a76';

export enum DynamicFieldUUIDs {
	Bestand = '4df4d256-ee53-495b-9b4a-b57f91f81a66',
	SKU = 'a7a53def-26af-4029-a330-b297b10c9480',
	Hersteller = '49099183-c441-4938-aa39-5d9fb1f86552',
	Bezeichnung = 'eb5da926-5e56-4f46-b770-5ea45e70778a',
	MwSt = '2f8af1d3-7040-41d4-9bea-26b4c93f6c99',
	EAN = 'bcf1121d-be44-47db-b415-743ff3a1dc40',
	Kurzbeschreibung = 'bf40b66f-3cc8-4159-bb6e-5daad6e01f16',
	HTMLLangbeschreibung = '19164f6d-eb2e-49af-9941-dfd2a3cabd15',
	Gewicht = '9664b023-2488-4f81-bd9f-a9b0ccf1f038',
	VersanddauerLieferzeit = '4b1c4182-7d70-40a6-b069-2949f028dfb2',
	Preis = '1c2183e2-31bb-4d9c-85ea-a89817d364ec',
	Bilder = '556525a8-b994-48bc-bb20-0132ed3625a9',
	GefahrgutFiles = '2f98bf3e-34fd-475e-8c33-7c1140c87478',
	ProduktGruppe1 = '1b05c914-e0e6-451a-b0e0-8190ae1f979a',
	ProduktGruppe2 = 'aa4019a0-c7cc-4b53-85d2-e344f025a0b9',
	ProduktGruppe3 = '170659ef-1289-45c5-9cac-dba9209ce134',
	// won't display automatically in detail-page (layoutDefinition) because "isTechnical" is true -> see dynamic-config-service for filtering
	GroupSKU = '144b3402-819c-4aa3-b662-2e3d888cf5f3',
}

export enum LabelUUIDs {
	Stock = '70c7c893-c09c-4127-a3a3-7a9800580434',
	Product = 'd41da417-fc79-490e-8963-3175f005e5ee'
}
